import * as React from "react";
import PropTypes from "prop-types";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import Theme from "../../App/Theme";

class TAppBar extends React.Component {
    //==================================================================================================================
    //
    //                                             Props and State
    //
    //==================================================================================================================

    static propTypes = {
        logo: PropTypes.any,
        caption: PropTypes.string,
        height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        showHamburger: PropTypes.bool,
        onHamburgerClick: PropTypes.func,
        onTitleClick: PropTypes.func,
        position: PropTypes.string,
        style: PropTypes.object,
    };

    static defaultProps = {
        logo: null,
        caption: "",
        height: 63,
        showHamburger: false,
        onTitleClick: () => {},
        onHamburgerClick: () => {},
        position: "absolute",
        style: {},
    };

    static testProps = {
        logo: <MenuIcon />,
        caption: "Caption",
        showHamburger: true,
        onTitleClick: () => console.log("onTitleClick fired"),
        onHamburgerClick: () => console.log("onHamburgerClick fired"),
        position: "static",
    };

    //==================================================================================================================
    //
    //                                                 Events
    //
    //==================================================================================================================

    onHamburgerClick = () => {
        this.props.onHamburgerClick();
    };

    onTitleClick = () => {
        this.props.onTitleClick();
    };

    //==================================================================================================================
    //
    //                                                Render
    //
    //==================================================================================================================

    render() {
        const styles = {
            flex: {
                flex: 1,
            },
            menuButton: {
                marginLeft: -12,
                marginRight: 20,
            },
        };

        return (
            <AppBar
                position={this.props.position}
                style={{
                    zIndex: Theme.zIndex.drawer + 1,
                    ...Theme.appBar,
                    height: this.props.height,
                }}
            >
                <Toolbar>
                    {this.props.showHamburger ? (
                        <IconButton
                            style={{ ...styles.menuButton }}
                            color="inherit"
                            aria-label="Menu"
                            onClick={this.onHamburgerClick}
                        >
                            <MenuIcon />
                        </IconButton>
                    ) : null}

                    <Typography
                        style={{
                            ...styles.flex,
                            cursor: "pointer",
                            ...this.props.style,
                            whiteSpace: "nowrap", // to prevent appbar height from changing
                        }}
                        variant="h6" //mark no longer applicable: "title"
                        color="inherit"
                        onClick={this.onTitleClick}
                    >
                        {this.props.logo}
                        {this.props.caption}
                    </Typography>

                    {this.props.children}
                </Toolbar>
            </AppBar>
        );
    }
}

export default TAppBar;
